"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areaColumnFullWidthProps = exports.areaColumnProps = exports.areaTypes = void 0;
const constants_1 = require("utils/constants");
exports.areaTypes = {
    SET_DATA_GRID: 'AREA TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'AREA TYPES ON PAGE CHANGE',
    ON_FILTER_CHANGE: 'AREA TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE: 'AREA TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'AREA TYPES ON MUTATION',
    ON_CHANGE_DATAITEM: 'AREA TYPES ON CHANGE DATAITEM',
    ON_SAVE_DATAITEM: 'AREA TYPES ON SAVE DATAITEM',
    ON_DELETE: 'AREA TYPES ON DELETE',
    SET_ERROR: 'AREA TYPES SET ERROR',
    SET_LOADING: 'AREA TYPES SET LOADING',
    GET_DETAIL: 'PIT TYPES GET DETAIL'
};
// total width px 1430 
exports.areaColumnProps = [
    {
        show: true,
        field: 'pit_name',
        title: 'Pit',
        width: '160px',
        filter: 'text'
    },
    {
        show: true,
        field: 'area_code',
        title: 'Area Code',
        width: '160px',
        filter: 'text'
    },
    {
        show: true,
        field: 'area_name',
        title: 'Area Name',
        width: '650px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.areaColumnFullWidthProps = [
    ...exports.areaColumnProps,
];
exports.areaColumnFullWidthProps[2] = {
    show: true,
    field: 'area_name',
    title: 'Area Name',
    width: 'auto',
    filter: 'text',
};
